import { useState, useEffect, useRef } from "react";
import { useNotification } from "../../../Hooks/useNotification";
import { useApiErrorHandler } from "../../../Hooks/useApiErrorHandler";
import useTokenRefresh from "../../../Hooks/useTokenRefresh";
import httpclient from "../../../Utils";

export const useFakeCustomer = (options = {}) => {
  const {
    autoFetch = true,
    pagination = { page: 0, pageSize: 20 },
    sorting = [],
    transformData = null,
  } = options;

  const [fakeCustomers, setFakeCustomers] = useState([]);
  const [customerCodes, setCustomerCodes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [rowCount, setRowCount] = useState(0);
const [allowAdd,setAllowAdd] = useState(1)
  const prevParams = useRef({
    page: pagination.page,
    pageSize: pagination.pageSize,
    sorting: JSON.stringify(sorting),
  });

  const showNotification = useNotification();
  const handleApiError = useApiErrorHandler();
  const { getTokenRefreshed: refresh } = useTokenRefresh();

  const fetchFakeCustomers = async (customParams = {}) => {
    const currentParams = {
      page: pagination.page,
      pageSize: pagination.pageSize,
      sorting: JSON.stringify(sorting),
    };

    try {
      setLoading(true);
      setError(null);

      const params = {
        page: pagination.page + 1,
        limit: pagination.pageSize,
        ...customParams,
      };

      if (sorting.length > 0) {
        const sortField = sorting[0].field;
        const sortOrder = sorting[0].sort;
        params.sortBy = sortField;
        params.sortOrder = sortOrder;
      }

      const res = await httpclient.get("/fake-customer", { params });
      const { data } = res;
setAllowAdd(data);
      if (data.status === 200) {
        const customers = transformData ? transformData(data.data) : data.data;
        setFakeCustomers(customers);
        setCustomerCodes(data.customer_codes);
        setRowCount(data.meta?.total || data.count || 0);

        // Update previous params after successful fetch
        prevParams.current = currentParams;
      } else {
        const errorMsg = data.msg || "Failed to fetch fake customers";
        setError(errorMsg);
        showNotification("error", errorMsg);
      }
    } catch (error) {
      const errorMsg = "Failed to fetch fake customers";
      setError(errorMsg);

      if (error.response?.status === 401) {
        refresh();
      } else {
        handleApiError(error);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (autoFetch) {
      fetchFakeCustomers();
    }
  }, [
    autoFetch,
    pagination.page,
    pagination.pageSize,
    JSON.stringify(sorting),
  ]);

  const refreshFakeCustomers = (params = {}) => {
    fetchFakeCustomers(params);
  };

  return {
    fakeCustomers,
    setFakeCustomers,
    customerCodes,
    loading,
    setLoading,
    error,
    rowCount,
    fetchFakeCustomers,
    refresh,
    refreshFakeCustomers,
    allowAdd
  };
};
